import { Component, input, output, computed } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Order } from '../../order.model';

@Component({
  selector: 'app-done-order-reminder',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './done-order-reminder.component.html',
  styleUrl: './done-order-reminder.component.css'
})
export class DoneOrderReminderComponent {
  doneOrders = input<Order[]>([]);
  
  cancel = output<void>();
  send = output<void>();

  ordersCount = computed(() => this.doneOrders().length);

  usersCount = computed(() => {
    const uniqueUserIds = new Set(this.doneOrders().map(order => order.userId));
    return uniqueUserIds.size;
  });

  lastReminderDate = computed(() => {
    return this.doneOrders()
      .filter(order => order.reminderSentAt)
      .reduce((max, order) => {
        const orderDate = order.reminderSentAt!.toDate();
        return max === null || orderDate > max ? orderDate : max;
      }, null as Date | null);
  });

  onCancel() {
    this.cancel.emit();
  }

  onSend() {
    this.send.emit();
  }
}
